import React, { useMemo, useState } from 'react';
import Form from 'react-bootstrap/esm/Form';
import { useDispatch, useSelector } from 'react-redux';
import { IReducer } from '../../../../../../../../redux/configureStore';
import {
  getAllPartnersList,
  setPartnerOption,
} from '../../../../../../../../redux/fetchActions/legadoPage/clientsApp';
import Wrapper from '../../../../../../../../shared/components/Wrapper';
import GetPartners from './function';

function SetPartner() {
  const dispatch = useDispatch();
  const [isActive, setIsActive] = useState(true);

  const profileUserState = useSelector(
    (reducer: IReducer) => reducer.userProfile
  );
  const profilePartnerState = useSelector(
    (reducer: IReducer) => reducer.partnerProfile
  );
  const filterState = useSelector(
    (reducer: IReducer) => reducer.clientsApp.partnersList
  );
  const clientsFilterState = useSelector(
    (reducer: IReducer) => reducer.clientsFilter
  );

  function setAccount(event: React.FormEvent<any>) {
    const { value } = event.currentTarget;
    dispatch(setPartnerOption(value));
  }

  const [partnerFilter, setPartnerFilter] = useState(filterState);

  useMemo(() => {
    if (profileUserState.partnerId === 1) {
      dispatch(getAllPartnersList());
      setIsActive(true);
    } else {
      setPartnerOption(profilePartnerState.idLegado.toString());
      setIsActive(false);
    }
  }, [profileUserState.nivel]);

  useMemo(() => {
    setPartnerFilter(filterState);
  }, [filterState]);

  return (
    <Wrapper.Default isActive={isActive} flexDirection="row">
      <span>Parceiro:</span>
      <Form.Control
        as="select"
        style={{ width: '11rem', margin: '0 1rem 0 0.25rem' }}
        value={clientsFilterState.partner}
        onChange={(event) => setAccount(event)}>
        <option key={0} value="todos">
          Global (382)
        </option>

        <GetPartners partnerFilter={partnerFilter} />
      </Form.Control>
    </Wrapper.Default>
  );
}

export default SetPartner;
